/* eslint-disable no-async-promise-executor */
/* eslint-disable no-console */
// import axios from 'axios';
/* global axios */
import ApiClient from '../../../../../api/ApiClient';

class GoogleAgendaService extends ApiClient {
  #auth_endpoint;

  #schedules_endpoint;

  constructor() {
    super('', { accountScoped: true });
    // this.#endpoint = this.url + 'google_calendar';
    this.#auth_endpoint = this.url + 'google_calendar';
    this.#schedules_endpoint = this.url + 'google_calendar_schedules';
  }

  /**
   * @returns {Promise<String|null>}
   */

  // ? START Google Auth methods
  getEmail = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`${this.#auth_endpoint}`);
        resolve(data.email || null);
      } catch (error) {
        reject(error);
      }
    });
  };

  deleteAuth = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.delete(`${this.#auth_endpoint}`);
        resolve(response || null);
      } catch (error) {
        reject(error);
      }
    });
  };
  // ? END Google Auth methods

  // ? START Schedules methods
  getSchedules = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`${this.#schedules_endpoint}`);
        resolve(data.calendars || []);
      } catch (error) {
        reject(error);
      }
    });
  };

  syncSchedules = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.patch(
          `${this.#schedules_endpoint}/sync_schedules`
        );
        resolve(response || null);
      } catch (error) {
        reject(error);
      }
    });
  };

  deleteAllSchedules = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.delete(
          `${this.#schedules_endpoint}/destroy_all`
        );
        resolve(response || null);
      } catch (error) {
        reject(error);
      }
    });
  };

  deleteSchedule = schedule_id => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.delete(
          `${this.#schedules_endpoint}/${schedule_id}`
        );
        resolve(response || null);
      } catch (error) {
        reject(error);
      }
    });
  };

  activeSchedule = ({ schedule_id, active }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.patch(
          `${this.#schedules_endpoint}/active_schedule`,
          { id: schedule_id, active: active }
        );
        resolve(response || null);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateBookableTimes = ({ schedule_id, bookable_times }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.patch(
          `${this.#schedules_endpoint}/bookable_times`,
          { id: schedule_id, bookable_times: bookable_times }
        );
        resolve(response || null);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateBlockedPeriods = ({ schedule_id, blocked_periods }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.patch(
          `${this.#schedules_endpoint}/blocked_periods`,
          { id: schedule_id, blocked_periods: blocked_periods }
        );
        resolve(response || null);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateServices = ({ schedule_id, services }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.patch(
          `${this.#schedules_endpoint}/services`,
          { id: schedule_id, services: services }
        );
        resolve(response || null);
      } catch (error) {
        reject(error);
      }
    });
  };
  // ? END Schedules methods
}
export const googleService = new GoogleAgendaService();
